// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入Element UI样式
import './iconfont/iconfont.css'
import axios from 'axios'


import { store } from '@/utils/store.js';



Vue.prototype.$axios = axios;
Vue.use(ElementUI);
Vue.config.productionTip = false

// 检测是否为手机设备
function isMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // 检测常见的手机 User-Agent
    return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
}

// 如果是手机用户，重定向到手机网页版
if (isMobile()) {
    window.location.href = 'https://www.jwocx.com/mobile/#/'; // 替换为你的手机网页版地址
} else {
    // 否则，继续加载桌面版
    new Vue({
        el: '#app',
        router,
        render: h => h(App),
        store  // 将 store 挂载到 Vue 实例中
    });
}


// WEBPACK FOOTER //
// ./src/main.js